<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required, url } from "vuelidate/lib/validators";
import SkeletonLoader from "../../../components/skeletons/skeleton-loader.vue";
import {
  MarketPlaces,
  IntegrationHandshake,
} from "../../../services/westore/entities";

// import IntegrationHandshake from "../../../services/westore/entities/integration-handshake";
//const alpha = helpers.regex("alpha", /^[A-Za-z/-]+$/);

export default {
  page: {
    title: "Create Integration",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    SkeletonLoader,
  },
  data() {
    return {
      title: "",
      subtitle: "",
      submitted: false,
      loader: false,
      isSuccess: false,
      user: JSON.parse(localStorage.getItem("user"))?.id,
      marketplace: {},
      integrated: false,
      showContentLoader: true,
      showPassword: false,
      logo: require("@/assets/images/integrations/westore.svg"),
      form: {
        store_url: null,
      },
    };
  },
  validations: {
    form: {
      store_url: { required, url },
    },
  },

  mounted() {
    this.showContentLoader = true;

    this.marketplace = this.$route.query;
    this.title = `${this.marketplace.marketName.toUpperCase()} INTEGRATION`;
    console.log(this.marketplace);
    if (this.marketplace.status === "Integrated") {
      this.integrated = true;
      this.form.store_url = `https://${this.marketplace.store_url}`;
    }
    this.showContentLoader = false;
  },

  methods: {
    async submitForm() {
      this.submitted = true;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loader = true;
        try {
          const { redirect_url } =
            await IntegrationHandshake.handle(
              this.marketplace.marketName.toLowerCase(),
              `?user_id=${this.user}&shop=${this.form.store_url}`
            );

          window.location.href = `${redirect_url}`;

          //   window.location.href = `${redirect_url}`;
        } catch (error) {
          console.log(error);
          this.$toast.error("Something went wrong,please try again");
        }
        setTimeout(() => {
          this.loader = false;
        }, 1000);
      }
    },
    async handleRemoveIntegration() {
      this.loader = true;
      try {
        await MarketPlaces.removeIntegration(this.marketplace.id);
        this.$toast.success("Your Integration has been removed Successfully");
      } catch (error) {
        this.$toast.error("Something went wrong,please try again");
      } finally {
        this.loader = false;
        this.$router.push({
          name: "integrations-board",
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :subtitle="subtitle" />
    <div class="row d-flex flex-row">
      <v-row v-if="showContentLoader">
        <v-col v-for="n in 2" :key="n" cols="6" xs="12">
          <SkeletonLoader type="image" />
        </v-col>
      </v-row>

      <b-row align-v="end" v-else>
        <b-col cols="12" md="5">
          <div class="shadow">
            <v-card elevation="0">
              <v-img
                class="westore-icon"
                :position="integrated ? 'top left' : 'top right'"
                :class="integrated && 'ml-5'"
                contain
                eager
                height="25"
                :src="logo"
              />
              <v-icon
                v-if="integrated"
                class="icon-box"
                color="success"
                size="30"
              >
                mdi-checkbox-marked
              </v-icon>
              <v-img contain eager height="200" :src="marketplace.logo" />
            </v-card>
          </div>
          <div v-if="integrated">
            <div class="text-muted py-5">
              <span class="font-size-15">Your Store URL</span>
              <v-icon class="mx-3">$vuetify.icons.line</v-icon
              ><span class="text-primary"> {{ this.form.store_url }}</span>
            </div>
            <div>
              <v-progress-circular
                v-if="loader"
                :size="30"
                color="secondary"
                indeterminate
                class="ml-10"
              ></v-progress-circular>
              <b-button
                v-else
                :loading="loader"
                variant="outline-danger"
                class="btn-block t"
                size="md"
                @click="handleRemoveIntegration"
              >
                <span class="fw-normal">Remove Integration</span>
              </b-button>
            </div>
          </div>
        </b-col>
        <b-col v-if="!integrated" cols="12" md="7" class="h-100">
          <div class="h-100" :class="$vuetify.breakpoint.xsOnly && 'h-auto'">
            <div class="d-flex align-end h-100">
              <b-form @submit.prevent="submitForm" class="flex-grow-1">
                <b-row>
                  <b-col cols="12" md="9">
                    <!-- marketplace Url-->
                    <b-form-group class="form-label">
                      <label size="md" for="store_url"
                        >Enter your Store URL*</label
                      >
                      <b-input-group class="shadow bg-white mt-1">
                        <b-form-input
                          v-model.number="form.store_url"
                          id="store_url"
                          type="url"
                          :readonly="integrated"
                          placeholder="https:// ......"
                          :class="{
                            'is-invalid': submitted && $v.form.store_url.$error,
                          }"
                        ></b-form-input>
                        <div
                          v-if="submitted && !$v.form.store_url.url"
                          class="invalid-feedback bg-white"
                        >
                          <span v-if="!$v.form.store_url.url"
                            >Enter a valid URL</span
                          >
                        </div>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <!-- Submit -->
                  <b-col cols="12" md="3" align-self="center" class="mt-sm-6">
                    <div class="text-center">
                      <v-progress-circular
                        v-if="loader"
                        :size="30"
                        color="primary"
                        indeterminate
                      ></v-progress-circular>
                      <b-button
                        v-else
                        :loading="loader"
                        type="submit"
                        variant="primary"
                        class="btn-block w-100"
                        size="md"
                      >
                        Integrate
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </b-form>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
.form-group {
  label {
    position: relative;
    padding-left: 10px;
    &::before {
      content: "";
      width: 5px;
      height: 15px;
      position: absolute;
      left: 0px;
      top: 3px;
      background: #48beea;
      border-radius: 4px;
    }
  }
}

.westore-icon {
  top: 15px;
  right: 5px;

  z-index: 9;
}
.shipment-manifest-file {
  border-radius: 4px;
  border: 1px dashed var(--v-primary-base);
  padding: 10px;

  .custom-file-input:lang(en) ~ .custom-file-label::after {
    content: "Browse";
  }

  .preview {
    display: inline-block;
    border-radius: 5px;
    border: 1px solid var(--v-primary-base);
    margin: 3px;
  }
}

.shipment-manifest-file.is-invalid {
  border-color: var(--v-error-base);
}
.icon-box {
  position: absolute;
  top: 8px;
  right: 10px;
  z-index: 200;
  &__custom {
    background-color: var(--v-info-base);
    padding: 9px;
    border-radius: 50%;
  }
}
</style>
